import { type StateType } from '../../states';
import { type RegulationState, type RegulationMessageState } from '../../states/regulation';
import { type Selector } from '../../types/selectors';

const emptyObj = {};

export const selectRegulationState: Selector<RegulationState> = (state: StateType) => state.regulation ?? emptyObj;

export const selectRegulationMessage: Selector<RegulationMessageState | undefined> = (state: StateType) =>
  selectRegulationState(state).message;

export const selectRegulationMessageUuid: Selector<string | undefined> = (state: StateType) =>
  selectRegulationMessage(state)?.uuid;
